import React from 'react';
import Description from 'gatsby-core-theme/src/components/atoms/author-box/description'

export default function index(props) {
  return (
    <Description {...props} contReadIcon={false} maximumLength={60} />
  )
}
